import {OtsFormFieldSize} from "../components/OtsFormField";
import {OtsEntitySelect} from "./OtsEntityMultiSelect";

export type OtsUnitOfMeasureOption = {
  value: string;
  label: string;
  abbreviation?: string;
};

export type OtsUnitOfMeasureSelectProps = {
  id?: string;
  label: string;
  description?: string;
  units: OtsUnitOfMeasureOption[];
  value?: string;
  onChange: (value: string | undefined) => void;
  disabled?: boolean;
  size?: OtsFormFieldSize;
  useAbbreviation?: boolean;
};

/** Searchable unit selector built on the shared single-entity selector. Values are database UOM names. */
export const OtsUnitOfMeasureSelect = ({
  id,
  label,
  description,
  units,
  value,
  onChange,
  disabled,
  size,
  useAbbreviation = true,
}: OtsUnitOfMeasureSelectProps) => (
  <OtsEntitySelect
    entityType="UNITOFMEASURE"
    label={label}
    description={description}
    options={units.map((unit) => ({
      value: unit.value,
      label: useAbbreviation && unit.abbreviation ? `${unit.abbreviation} · ${unit.label}` : unit.label,
    }))}
    value={value}
    onChange={onChange}
    disabled={disabled}
    size={size}
    {...(id ? {id} : {})}/>
);
